var $04c60c697ee9de36$exports = {};
const $04c60c697ee9de36$var$username = "moniabysiak";
const $04c60c697ee9de36$var$direction = "desc";
const $04c60c697ee9de36$var$repositoriesContainer = document.querySelector(".repositories--js");
fetch(` https://api.github.com/users/${$04c60c697ee9de36$var$username}/repos?direction=${$04c60c697ee9de36$var$direction}`).then((response)=>response.json()).then((response)=>{
    for (let repository of response){
        const { name: name, html_url: html_url } = repository;
        const element = `<li><a href="${html_url}">${name}</a></li>`;
        $04c60c697ee9de36$var$repositoriesContainer.insertAdjacentHTML("beforeend", element);
    }
}).catch((e)=>console.log(e));


//# sourceMappingURL=index.e374805e.js.map
